import CalendarShot from './shots/CalendarShot'
import NewGoalShot from './shots/NewGoalShot'
import ProgressShot from './shots/ProgressShot'

const Features = () => (
    <section className="features" id="features">
        <div className="gt-container">
            <div className="frow" data-reveal>
                <div className="frow__copy">
                    <span className="eyebrow">CAPACITY</span>
                    <h3>Set capacity.</h3>
                    <p>Name the goal. Set weekly hours or sessions. If the date does not fit, General Task says so.</p>
                </div>
                <div className="frow__shot">
                    <NewGoalShot />
                </div>
            </div>

            <hr className="frow__rule" />

            <div className="frow frow--flip" data-reveal>
                <div className="frow__copy">
                    <span className="eyebrow">PROGRESS</span>
                    <h3>Count real work.</h3>
                    <p>
                        Done tasks and calendar blocks credit the goal. If it slips, change the pace, date, week, or
                        pause.
                    </p>
                </div>
                <div className="frow__shot">
                    <ProgressShot />
                </div>
            </div>

            <hr className="frow__rule" />

            <div className="frow" data-reveal>
                <div className="frow__copy">
                    <span className="eyebrow">CALENDAR</span>
                    <h3>Sync calendar both ways.</h3>
                    <p>Meetings come in from Google Calendar. Task blocks made here go back.</p>
                </div>
                <div className="frow__shot">
                    <CalendarShot />
                </div>
            </div>
        </div>
    </section>
)

export default Features
